import React, { useState, useEffect, useCallback } from "react";

interface Props {
  value: number | null;
  onChange: (v: number | null) => void;
  className?: string;
  onEnter?: () => void;
  type: "default" | "min" | "max";
}

const InputInstance: React.FC<Props> = ({ value, onChange, className, onEnter, type }) => {
  const [displayVal, setdisplayVal] = useState<string>(value?.toString() || "");
  const onChangeDisplayVal = useCallback(
    (val: number | null) => {
      if (!val && type === "max") {
        setdisplayVal("∞");
      } else if (!val) {
        setdisplayVal("0");
      } else {
        setdisplayVal(val.toString());
      }
    },
    [type]
  );

  useEffect(() => {
    onChangeDisplayVal(value);
  }, [onChangeDisplayVal, value]);

  return (
    <div className={`flex items-center ${className || ""}`}>
      <input
        className="border- w-8 border-b border-t-0 border-l-0 border-r-0 border-gray-300 bg-transparent px-1 text-right text-sm outline-none focus:outline-none focus:ring-0 "
        type="text"
        value={displayVal}
        onChange={(e) => {
          const string = e.target.value.replace(/[^\d|.|-]/, "");
          let val: number | null = parseFloat(string);
          val = parseFloat(val.toFixed(0));
          if (type === "max" && (val === 0 || Number.isNaN(val))) val = null;
          else if (Number.isNaN(val)) val = 0;
          onChange(val);
        }}
        onKeyDown={(e) => e.key === "Enter" && onEnter && onEnter()}
      />
    </div>
  );
};
export default InputInstance;
